import {ACCESS_MAP, APP_SUBGROUPS} from './accessMap';

const PORTAL_NAME = 'The Catalight Care Services Provider Portal';
/** The offer pages and the landing redirect are steps of client placement, and sit off the nav. */
const FALLBACK_PAGE = 'Client Placement';

const isAtOrBelow = (path: string, route: string) => path === route || path.startsWith(`${route}/`);

/**
 * The browser tab title for a path inside the provider app, using the nav's name for the page. A
 * page below a destination, such as a client's details, takes that destination's name. A page in a
 * nav sub-group leads with the group, because "Export" alone does not say what is exported.
 */
export const pageTitle = (path: string): string => {
    const destination = ACCESS_MAP
        .filter((entry) => isAtOrBelow(path, entry.route))
        .sort((a, b) => b.route.length - a.route.length)[0];
    if (!destination) {
        return `${FALLBACK_PAGE} - ${PORTAL_NAME}`;
    }
    const group = APP_SUBGROUPS.find((subGroup) => subGroup.key === destination.subGroup);
    const page = group ? `${group.label} ${destination.label}` : destination.label;
    return `${page} - ${PORTAL_NAME}`;
};
